const WS10_HIDDEN = 'ws10-is-hidden';

/**
 * Show HTMLElement (or hide with show=false)
 * @param elementOrId
 * @param show
 */
export const showElement = (elementOrId: Element | null | string, show: boolean = true) => {
    const element = elementOrId instanceof Element ? elementOrId : document.getElementById(elementOrId || '');

    element?.classList.toggle(WS10_HIDDEN, !show);
};

/**
 * Show HTMLElements (or hide with show=false)
 * @param componentArray
 * @param show
 */
export const showElements = (componentArray: (Element | null | string)[], show: boolean = true) => {
    componentArray.forEach(component => showElement(component, show));
};
